// extracted by mini-css-extract-plugin
module.exports = {"space":"Preparando1_space__3kObI","rowClass":"Preparando1_rowClass__3RaHq","precioFinal":"Preparando1_precioFinal__17LLA"};